<ems-base-text-style [variation]="status.textStyleVariation">
  {{ status.displayedValue }}
</ems-base-text-style>
